module.exports = __webpack_public_path__ + "static/img/wd_banner.89c8932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/wd_banner.png
// module id = q5Dy
// module chunks = 1